import React, { FC, useRef } from 'react'
import Delivery from '../../../assets/icons/delivery.svg'
import TakeAway from '../../../assets/icons/take-away.svg'
import { ColorsEnum } from '../../constants/colors'
import { OrderSourceEnum, sourceIcons } from '../../constants/order'
import { getCountdown } from '../../helpers/getCountdown'
import { getDeliveryDate } from '../../helpers/getDeliveryDate'
import { useAppSelector } from '../../hooks/redux'
import { useTimeState } from '../../hooks/useTimeState'
import { appSelectors } from '../../redux/reducers/app'
import DateTime from '../UI/OrderCard/DateTime'
import InfoBar from '../UI/OrderCard/InfoBar'
import InfoButton from './InfoButton'

interface OrderInfoBarProps {
    isAddressRequired: boolean
    code: string
    dateTime: {
        type: string
        since?: string
        until?: string
        date?: string
        finishedAt?: string
        driverPickupTime?: string
    }
    customer: {
        name: string
        phone?: string
        address?: string
    }
    source: OrderSourceEnum
    orderKey: string
}

const OrderInfoBar: FC<OrderInfoBarProps> = ({
    isAddressRequired,
    code,
    dateTime,
    customer,
    source,
    orderKey,
}) => {
    const isArchive = useAppSelector(appSelectors.isArchive)

    const countdownState = useTimeState(
        () =>
            dateTime.driverPickupTime
                ? getCountdown('exact', dateTime.driverPickupTime)
                : getCountdown(dateTime.type, dateTime.until, dateTime.date, dateTime.finishedAt),
        60000,
        isArchive
    )

    const customerRef = useRef(customer)

    const [countdown, isLate] =
        !isArchive || dateTime.finishedAt ? countdownState : [undefined, false]
    const deliveryDate = dateTime.driverPickupTime
        ? getDeliveryDate('exact', undefined, dateTime.driverPickupTime)
        : getDeliveryDate(dateTime.type, dateTime.since, dateTime.until, dateTime.date)

    const textColor = !isLate ? ColorsEnum.DARK : '#FFFFFF'

    return (
        <InfoBar color={!isLate ? ColorsEnum.GRAY : ColorsEnum.PRIMARY}>
            <DateTime
                countdown={countdown}
                deliveryDate={deliveryDate}
                textColor={textColor}
                SourceIcon={sourceIcons[source]}
                DeliveryIcon={isAddressRequired ? Delivery : TakeAway}
            />
            <InfoButton
                code={code}
                customer={customerRef.current}
                textColor={textColor}
                orderKey={orderKey}
            />
        </InfoBar>
    )
}

export default OrderInfoBar
